import { apiConstants } from '../../apiConstant'
import { formDataCommonFunctionPutWithoutAuth, serviceCallAuth } from '../../serviceCall'

export const activateUser = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunctionPutWithoutAuth(data, apiConstants.AUTH.ACTIVATE_USER)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
